import React, { FC } from "react";
import { Link as MuiLink, LinkProps } from "@mui/material";

//TODO: use instead import { Link } from "react-router-dom"; ?

const Link: FC<LinkProps> = (props) => <MuiLink {...props} />;

export default Link;
